import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './card.module.scss';


export function Card ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.root, className ) }
            data-template="card"
            { ...props }
        />
    );
}
